// extracted by mini-css-extract-plugin
module.exports = {"filter":"style_filter__bzK7I"};